import { useRef } from 'react';

import { logger } from '@zep/core-logger';

import { type EventProperties } from '@/utils/analytics';
import { useBuildInfoContext } from '@/views/build/context';
import { useBuildFormContext } from '@/views/build/form/schema';
import { getBuildType } from '@/views/build/util/getBuildType';

import { mapTemplateSelectModal } from '../index';

export const useShowMapTemplateModal = () => {
  const { action, mapTemplates, userCountryCode } = useBuildInfoContext();
  const { watch, setValue } = useBuildFormContext();
  const templateId = watch('templateId');
  const buildType = getBuildType(action);

  const isOpened = useRef(false);

  const open = async (options?: { from?: string; isChange?: boolean }) => {
    isOpened.current = true;

    const eventProperties: EventProperties = {
      from: options?.from || 'unknown',
      is_change: options?.isChange || false,
    };

    const isMapSubmitted = await mapTemplateSelectModal.openAsync({
      selectedMapTemplateId: templateId,
      mapTemplates,
      userCountryCode,
      isChange: options?.isChange,
      onSubmit: (selectedTemplateId, type) => {
        if (selectedTemplateId === templateId) {
          return;
        }

        setValue('templateId', selectedTemplateId, {
          shouldDirty: true,
        });
        setValue('templateType', type, {
          shouldDirty: true,
        });
        logger.track('map_select_completed', {
          ...eventProperties,
          build_type: buildType,
        });
      },
      onClose: () => {
        logger.track('map_select_canceled', eventProperties);
      },
    });
    isOpened.current = false;
    return isMapSubmitted;
  };

  return { open, isOpened };
};
